<template>
  <v-app>
    <v-layout column fill-height>
      <v-navigation-drawer v-model="drawer" color="primary" app floating right width="230">
        <div class="date-container d-flex d-md-none text-primary">
          <DateAndTimeComponent class="w-100 py-4 justify-center" />
        </div>

        <v-treeview class="white--text font-weight-bold" :items="items" :open.sync="open" open-on-click activatable
          :active.sync="active" active-class="active" transition>
          <template v-slot:prepend="{ item }">
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </template>

          <template v-slot:label="{ item }">
            <div v-if="!item.children">
              <router-link class="white--text d-block w-100" :to="item.link">
                {{ item.name }}
              </router-link>
            </div>
            <div v-else>{{ item.name }}</div>
          </template>
        </v-treeview>

        <div @click="logout" class="sign-out-btn mt-10 px-5 d-flex d-md-none white--text">
          <v-icon class="mr-1 ml-2" color="white">mdi-logout</v-icon>
          <div class="mr-1">خروج</div>
        </div>

        <div class="sign-out-btn white--text d-flex">
          <a href="https://vitech.codes/">
            <img class="mt-10" src="../assets/images/logo3.svg" width="190px" alt="logo">
          </a>
        </div>
      </v-navigation-drawer>

      <v-app-bar class="app" app color="primary" :elevation="2">
        <div class="d-flex align-center justify-space-between fill-height w-100">
          <div class="d-flex align-center h-100">
            <div class="d-flex d-md-none align-center w-25 h-100 mr-2" @click="drawer = true">
              <v-icon color="white" size="xx-large">
                mdi-menu
              </v-icon>
            </div>
          </div>

          <div class="d-flex align-center justify-center fill-height">
            <div class="date-container d-none d-md-flex pl-6 text-primary">
              <DateAndTimeComponent />
            </div>

            <div @click="logout" class="sign-out-btn d-none d-md-flex white--text">
              <v-icon color="white">mdi-logout</v-icon>
              <div class="mr-1">خروج</div>
            </div>

            <p class="text-h6 text-md-h5 pr-6 mb-0 white--text">Ava Kids</p>
          </div>
        </div>
      </v-app-bar>

      <v-main class="my-8 mx-3 mx-md-16">
        <v-scroll-y-transition mode="out-in">
          <router-view />
        </v-scroll-y-transition>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script>
import { RouterLink, RouterView } from 'vue-router';
import DateAndTimeComponent from "@/components/Layout/DateAndTimeComponent.vue"

export default {
  data: () => ({
    group: null,
    drawer: false,
    open: [],
    active: [],
    // menu items
    items: [
      // dashboard
      {
        id: 1,
        name: "داشبورد",
        icon: "mdi-home",
        link: "/",
      },
      // users
      {
        id: 2,
        name: "کاربران",
        icon: "mdi-clipboard-account",
        children: [
          {
            id: 21,
            name: "فرزند دارد",
            link: "/users-with-children",
          },
          {
            id: 22,
            name: "فرزند ندارد",
            link: "/users-not-children",
          },
          {
            id: 23,
            name: "مادر باردار",
            link: "/users-is-pregnant",
          },
        ],
      },
      // nutrition
      {
        id: 3,
        name: "تغذیه",
        icon: "mdi-food-apple",
        children: [
          {
            id: 31,
            name: "وعده های غذایی",
            link: "/foods-list",
          },
          {
            id: 32,
            name: "تغذیه کاربران",
            link: "/users-foods-list",
          },
          {
            id: 33,
            name: "فیدبک تغذیه",
            link: "/foods-feedback",
          },
          {
            id: 34,
            name: "الگوی غذایی",
            link: "/foods-pattern",
          },
          {
            id: 35,
            name: "بانک مواد اولیه",
            link: "/foods-ingredients",
          },
        ],
      },
      //Tools
      {
        id: 4,
        name: "ابزارها",
        icon: "mdi-gamepad-circle",
        children: [
          // {
          //   id: 81,
          //   name: "بازی",
          //   link: "/tools/games/list",
          // },
          {
            id: 82,
            name: "خواب",
            link: "/tools/sleep/list",
          },
          {
            id: 83,
            name: "پادکست",
            link: "/tools/podcast/list",
          },
          {
            id: 84,
            name: "بایدهاو نبایدها",
            link: "/tools/dos-donts",
          },
          {
            id: 85,
            name: "ویدیوهای آموزشی",
            link: "/tools/educationalVideos/list",
          },
          {
            id: 32,
            name: "مقالات",
            link: "/tools/articles/list",
          },
        ],
      },

      // questionnaire
      {
        id: 5,
        name: "پرسشنامه",
        icon: "mdi-help-box-multiple",
        children: [
          {
            id: 131,
            name: "پرسشنامه کاربران",
            link: "/users-questions",
          },
          {
            id: 132,
            name: "لیست پرسشنامه",
            link: "/questions-list",
          },
          {
            id: 133,
            name: "دسته بندی پرسشنامه",
            link: "/questions-category",
          },
          // {
          //   id: 131,
          //   name: "پرسشنامه اولیه",
          //   link: "/initial-questionnaire/list",
          // },
          // {
          //   id: 132,
          //   name: "پرسشنامه ذهنی",
          //   link: "/mental-answers",
          // },
        ],
      },
      {
        id: 6,
        icon: "mdi-account-group",
        name: "انجمن",
        children: [
          {
            id: 102,
            name: "لیست انجمن ها",
            link: "/forum",
          },
          {
            id: 101,
            name: "لیست درخواست ها",
            link: "/forum-user-request",
          },
        ],
      },

      {
        id: 18,
        icon: "mdi-chart-areaspline",
        name: "استان‌های رایگان",
        link: "/free-provinces",
      },
      {
        id: 7,
        icon: "mdi-chart-areaspline",
        name: "سوابق مالی",
        link: "/payment",
      },
      {
        id: 8,
        icon: "mdi-message-question",
        name: "تیکت ها",
        link: "/ticket",
      },
      {
        id: 17,
        name: "کد تخفیف",
        icon: "mdi-percent-outline",
        link: "/discount-code",
      },
      {
        id: 9,
        icon: "mdi-account-switch",
        name: "مشاوره",
        link: "/counseling",
      },
      {
        id: 102,
        icon: "mdi-shield-lock",
        name: "قوانین و مقررات",
        link: "/rules",
      },
      {
        id: 11,
        icon: "mdi-message-check",
        name: "لیست پیام ها",
        link: "/messages",
      },
      {
        id: 12,
        icon: "mdi-timeline-question",
        name: "سوالات متداول",
        link: "/faq",
      },
      // about us
      {
        id: 13,
        icon: "mdi-account-tie",
        name: "درباره ما",
        link: "/about",
      },
      {
        id: 14,
        icon: "mdi-message-bulleted",
        name: "پیام برودکست",
        link: "/broadcast",
      },
      {
        id: 15,
        icon: "mdi-package",
        name: "پکیج ها",
        link: "/package",
      },
      {
        id: 16,
        icon: "mdi-image",
        name: "بنرها",
        link: "/banner",
      },
    ],
  }),

  watch: {
    group() {
      this.drawer = false;
    },

    '$vuetify.breakpoint.width'() {
      this.drawer = this.$vuetify.breakpoint.mdAndUp;
    },
  },

  methods: {
    logout() {
      localStorage.removeItem("token")
      this.$router.replace("/login")
    }
  },
  mounted() {
    // Initialize correctly on first load
    this.drawer = this.$vuetify.breakpoint.mdAndUp;
  },
  components: {
    RouterLink,
    RouterView,
    DateAndTimeComponent
  },
}
</script>

<style scoped>
.date-container {
  align-self: stretch;
}

.sign-out-btn {
  position: sticky;
  bottom: 0;
  background-color: #329988;
  cursor: pointer;
}
</style>
